import React, { useState } from "react";
import { FiSearch } from "@react-icons/all-files/fi/FiSearch";

import { useNavigate, useSearchParams } from "react-router-dom";

function Search() {
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const searchUrl = searchParams.get("search") || "";
  const handleSubmit = (e) => {
    e.preventDefault();
    if (search.trim() && searchUrl !== search) {
      navigate(`/?search=${search || "none"}`);
    }
    if (!search) {
      navigate(`/`);
    }
  };
  return (
    <div className="bg-primary z-10 flex justify-center items-center max-w-[100%] overflow-hidden w-[850px] h-[211px]  absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-[140%]">
      <form onSubmit={handleSubmit} className="relative w-[100%]">
        <h1 className="absolute text-primary z-0 pointer-events-none mark font-SoraB text-[185px] left-1/2 -translate-x-1/2 -translate-y-[25%] tablet:-translate-y-1/2 tablet:top-1/2">
          SEARCH
        </h1>
        <div className="flex tablet:my-10 flex-col justify-center items-center z-10 space-y-[15px]">
          <h2 className="font-size z-10 text-center break-words px-4 w-full text-tertiary">
            Discover Great Reads
          </h2>
          {/* <div className="z-10 flex tablet:w-[100%] w-[130%] relative px-8"> */}
          <div className="z-10 flex w-[100%] px-[15%] tablet:px-[20px] relative">
            <div className="flex-1">
              <input
                className="w-[100%] tablet:text-[15px] font-SoraR px-6 capitalize placeholder:text-secondary outline-none h-[63px]"
                type="text"
                placeholder="Search For Your Novel..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <button
              id="Search"
              title="Search"
              className="cursor-pointer hover:bg-secondary/90 duration-300 ease-in-out w-[63px] flex-0 bg-secondary flex justify-center items-center text-tertiary"
            >
              <FiSearch className="h-[25px] w-[25px]" />
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Search;
